// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";
// import React from "react";
// import { styles } from "./PageLayoutStyle";
// import headerImg from "../assets/header.jpg";
// import footerImg from "../assets/footer.jpg";

// const PageLayout = ({ children, pageNo, company }) => {
//   function returnSrc(path = "") {
//     return {
//       uri: path,
//       method: "GET",
//       body: "",
//       headers: { "Cache-Control": "no-cache" },
//     };
//   }
//   console.log("company...........company....", company);
//   let iamge = `https://s3.ap-south-1.amazonaws.com/slg-dev/sla/company/logo/WhatsApp%20Image%202024-07-18%20at%2010.19.54company_logoHzG7.jpg`;
//   return (
//     <Page size="A4" style={styles?.page} wrap>
//       <View style={styles?.header} fixed>
//         {/* <Image
//           src={
//             company?.header && company?.header != ""
//               ? returnSrc(company?.header)
//               : headerImg
//           }
//           style={styles?.logo1}
//         /> */}
//         <Image src={iamge} style={styles?.logo1} />
//       </View>
//       {children}
//       <View style={styles?.footer} fixed>
//         <Image
//           src={
//             company?.footer && company?.footer != ""
//               ? returnSrc(company?.footer)
//               : footerImg
//           }
//           style={styles?.logo1}
//         />
//       </View>
//     </Page>
//   );
// };

// export default PageLayout;

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { styles } from "./PageLayoutStyle";
import headerImg from "../assets/header.jpg";
import footerImg from "../assets/footer.jpg";

const PageLayout = ({ children, pageNo, company }) => {
  const [base64String, setBase64String] = useState("");
  let iamge = `https://s3.ap-south-1.amazonaws.com/slg-dev/sla/company/logo/WhatsApp%20Image%202024-07-18%20at%2010.19.54company_logoHzG7.jpg`;
  useEffect(() => {
    const convertImageToBase64 = async (url) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          setBase64String(reader.result);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error fetching or converting the image:", error);
      }
    };
    if (company?.header) {
      convertImageToBase64(company?.header);
    }
  }, []);
  function returnSrc(path = "") {
    return {
      uri: path,
      method: "GET",
      body: "",
      headers: { "Cache-Control": "no-cache" },
    };
  }

  return (
    <Page size="A4" style={styles?.page} wrap>
      <View style={styles?.header} fixed>
        <Image
          src={
            base64String && base64String != ""
              ? returnSrc(company?.header)
              : headerImg
          }
          style={styles?.logo1}
        />
      </View>

      {children}

      <View style={styles?.footer} fixed>
        <Image
          src={
            company?.footer && company?.footer != ""
              ? returnSrc(company?.footer)
              : footerImg
          }
          style={styles?.logo1}
        />
      </View>
    </Page>
  );
};

export default PageLayout;
